import styled from "styled-components";
// import { MODAL_FADE_IN_TIME, MODAL_FADE_OUT_TIME, MODAL_IMAGE_TRANSITION_TIME } from "./index";

export const MODAL_FADE_IN_TIME = 200; // in ms
export const MODAL_FADE_OUT_TIME = 200; // in ms
export const MODAL_IMAGE_TRANSITION_TIME = 200; // in ms
export const Styled = styled.div`
    --modal-fade-in-time: ${MODAL_FADE_IN_TIME}ms;
    --modal-fade-out-time: ${MODAL_FADE_OUT_TIME}ms;

    /* minus topbar and footer */
    --lightbox-image-max-height: calc(100vh - 3.5rem - 3.5rem);

    position: fixed;
    z-index: 1100;
    font-size: 1.1rem; 
    color: #bfbfbf;

    &.lightbox-modal-root {
        &.exiting {
            animation: fadeOut ${MODAL_FADE_OUT_TIME + 50}ms ease-in-out;
        }
    }

    .lightbox-modal-mask,
    .lightbox-modal-wrap {
        position: fixed;
        inset: 0;
        z-index: 1000;
        height: 100%;
        animation: fadeIn var(--modal-fade-in-time) ease-in-out;
    }

    .lightbox-modal-mask {
        /* background-color: none;
        transition: background-color 600ms linear; */
        &.active {
            backdrop-filter: blur(10px);
            background-color: rgba(0, 0, 0, 85%);
            opacity: 1;
        }
    }

    .lightbox-modal-wrap {   
        display: flex;
        align-items: center;
        justify-content: center;
        overflow: auto;
        outline: 0;
    }

    .lightbox-btn {
        z-index: 1005;
        padding: 8px 10px 9px;
        font-size: 1.25rem;
        cursor: pointer;
        background-color: rgba(0, 0, 0, 30%);
        border-radius: 10px;

        &.arrow-left {
            position: absolute;
            top: 50%;
            left: 1rem;
        }

        &.arrow-right {
            position: absolute;
            top: 50%;
            right: 1rem;
        }

        &:hover {
            color: black;
            background-color: rgba(255, 255, 255, 75%);
            transition: background-color 0.3s, color 0.3s;
        }
    }

    .lightbox-modal-topbar,
    .lightbox-modal-footer {
        position: absolute;
        left: 0;
        display: flex;
        width: 100%;
        padding: 1rem;
        line-height: normal;
        
        &.lightbox-modal-topbar {
            top: 0;
            justify-content: space-between;
            
            .topbar__counter {
                display: inline-flex;
                align-items: center;
            }

            .topbar_btn-group {
                .topbar__download-icon {
                    a {
                        color: #bfbfbf;
                    }
                }
                .topbar__close-icon {}

                span:not(:first-child) {
                    margin-left: 0.85rem;
                }
            }

            &.counter-hidden {
                justify-content: flex-end;
            }
        }

        &.lightbox-modal-footer {
            bottom: 0;
            justify-content: center;
            color: white;

            .footer__file-name {
                display: inline-flex;
                align-items: center;
                text-align: center;
            }
        }
    }

    .lightbox-modal {
        /* opacity: 0%; */
        z-index: 1002;
        width: 97%;
        animation: modalEntry var(--modal-fade-in-time) cubic-bezier(0.425, 0.340, 0.000, 1.165);

        .lightbox-content-wrapper > * {
            max-width: 100%;
            max-height: var(--lightbox-image-max-height);
        }

        .lightbox-content-wrapper > iframe {
            border: none;
        }

        .lightbox-content-wrapper {
            z-index: 1003;
            display: flex;
            align-items: center;
            justify-content: center;
            width: 100%;
            height: var(--lightbox-image-max-height);
            animation: contentTransitionEntry ${MODAL_IMAGE_TRANSITION_TIME}ms ease-in-out;
        }

        &.exiting {
            animation: modalExit var(--modal-fade-out-time) ease-in-out;
        }

        &.moving {
            overflow: hidden;

            &.left {
                --transition-start-transform: translate(0%, 0%) scale(1.0);
                --transition-end-transform: translate(-100vw, 0%) scale(0);
            }

            &.right {
                --transition-start-transform: translate(0%, 0%) scale(1);
                --transition-end-transform: translate(100vw, 0%) scale(0);
            }

            .lightbox-content-wrapper {
                animation: contentTransitionExit ${MODAL_IMAGE_TRANSITION_TIME + 50}ms ease-in-out
            }
        }
    }


    @keyframes modalEntry {
        from { 
            opacity: 0; 
            transform: scale(0.0);
        }

        to { 
            opacity: 1; 
            transform: scale(1.0);
        }
    }

    @keyframes modalExit {
        from { 
            opacity: 1; 
            transform: translate(0, 0) scale(1.0);
        }

        to { 
            opacity: 0; 
            transform: translate(20rem, 20rem) scale(0);
        }
    }

    @keyframes fadeIn {
        from { 
            opacity: 0; 
        }

        to { 
            opacity: 1; 
        }
    }

    @keyframes fadeOut {
        from { 
            opacity: 1; 
        }

        to { 
            opacity: 0; 
        }
    }

    @keyframes contentTransitionExit {
        from { 
            opacity: 1; 
            transform: var(--transition-start-transform);
        }

        to { 
            opacity: 0; 
            transform: var(--transition-end-transform);
        }
    }

    @keyframes contentTransitionEntry {
        from { 
            opacity: 0; 
        }

        to { 
            opacity: 1; 
        }
    }

    .lightbox-all-files-preview {

    }
 
`;
